import styled from 'styled-components'

export const Values = styled('li')`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[17]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: 24px;
  margin-top: ${({ marginTop }) => marginTop};
  max-width: ${({ maxWidth }) => maxWidth}px;
  width: 100%;
  &::marker {
    color: ${({ theme }) => theme.colors.secondary};
  }
  & > a {
    color: ${({ theme }) => theme.colors.primary};
  }
  & > span {
    color: ${({ theme }) => theme.colors.darkGray};
    font-weight: ${({ theme }) => theme.fontWeight[7]}px;
  }

  ${({ theme, marginTop }) => theme.below.laptopL`
    font-size: ${theme.fontSizes[2]}px;
    margin-top: ${marginTop};
  `}
`
export const Wrapper = styled('ul')`
  list-style-type: ${({ typeOfMarker }) => typeOfMarker};
  margin-left: 41px;
  ${({ hexagonMarker }) =>
    hexagonMarker && "list-style-image: url('/images/list-hexagon.webp')"}
`
